import React from 'react';

import { IntroSection } from './IntroSection';
import { WhatDoYouGetSection } from './WhatDoYouGetSection';
import { FunctionSection } from './FunctionSection';
import { ServiceSection } from './ServiceSection';
import { AboutUsSection } from './AboutUsSection';
import { HowWeWorkSection } from './HowWeWorkSection';
import { ContactSection } from './ContactSection';
import { PartnersSection } from './PartnersSection';

export const IndexView = () => {
    return (
        <>
            <IntroSection />
            <WhatDoYouGetSection />
            <FunctionSection />
            <ServiceSection />
            <AboutUsSection />
            <HowWeWorkSection />
            <PartnersSection />
            <ContactSection />
        </>
    );
};
